import converter from 'xml-js'

export const xmltojson = (text='') => {
  return converter.xml2json(text, {compact: true, spaces: 3})
}